import * as React from "react";

export type LogoProps = {
  className?: string;
  width?: number;
  height?: number;
};

export function Logo({ className, width = 132, height = 28 }: LogoProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 132 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Escuela Vial"
    >
      <g>
        <circle cx="6" cy="7" r="3" fill="#DC2626" />
        <circle cx="6" cy="14" r="3" fill="#EAB308" />
        <circle cx="6" cy="21" r="3" fill="#16A34A" />
      </g>
      <text
        x="16"
        y="19"
        fontFamily="Inter, ui-sans-serif, system-ui"
        fontSize="16"
        fontWeight="700"
        fill="#111827"
      >
        <tspan fill="#E11D48">e</tspan>
        <tspan>scuela</tspan>
        <tspan dx="4" fill="#EAB308">
          v
        </tspan>
        <tspan fill="#16A34A">i</tspan>
        <tspan fill="#111827">al</tspan>
      </text>

      <g strokeLinecap="round" strokeWidth="3" transform="translate(-10 0)">
        <line x1="26" y1="24" x2="64" y2="24" stroke="#E11D48" />
        <line x1="68" y1="24" x2="96" y2="24" stroke="#EAB308" />
        <line x1="100" y1="24" x2="126" y2="24" stroke="#16A34A" />
      </g>
    </svg>
  );
}
